import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getAchievementsHandler, { IUserAchievement } from "./get-achievements.handler";

export interface IAchievementsState extends IRequestState {
    items: IUserAchievement[];
};

const initialState: IAchievementsState = {
    items: [],

    loading: false,
    error: "",
};

const achievementsSlice = createSlice({
    name: 'achievements',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<IAchievementsState>) => {
        getAchievementsHandler(builder);
    },
});

export default achievementsSlice.reducer;